import { LocalizedTranslations } from '../localizedTranslations';

export const es: LocalizedTranslations = {
  // Navigation
  nav: {
    home: 'Inicio',
    europeanMarkets: 'Mercados Europeos',
    aboutUs: 'Sobre Nosotros',
    products: 'Productos',
    oemSolutions: 'Soluciones OEM',
    blog: 'Blog',
    clientHub: 'Portal de Clientes',
    agentLogin: 'Acceso Agentes',
    contact: 'Contacto',
    getStarted: 'Comenzar',
    smartToilets: 'Inodoros Inteligentes',
    businessSolutions: 'Soluciones Empresariales',
    technology: 'Tecnología',
    about: 'Acerca de',
    viewAllProducts: 'Ver Todos los Productos',
    flagship: 'Insignia',
    productDescriptions: {
      rem7: 'Nuestro Inodoro Inteligente Premier',
      luxa: 'Línea de Lujo Supremo',
      luna: 'Compacto Minimalista',
      nova: 'Inodoro Inteligente Familiar',
      aria: 'Diseño Eco-Lujo',
      vena: 'Bidé Premium',
      aurelius: 'Elegancia Clásica',
      aurelux: 'Edición Acentos Dorados',
      luma: 'Innovación Inteligente',
    },
  },
  
  // Common
  common: {
    learnMore: 'Más Información',
    viewDetails: 'Ver Detalles',
    requestQuote: 'Solicitar Presupuesto',
    downloadCatalog: 'Descargar Catálogo',
    contactUs: 'Contáctenos',
    readMore: 'Leer Más',
    seeAll: 'Ver Todo',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    submit: 'Enviar',
    send: 'Enviar',
    close: 'Cerrar',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
  },
  
  // Homepage
  home: {
    heroTitle: 'Inodoros Inteligentes Premium para Mercados Europeos',
    heroSubtitle: 'Experimente el futuro del lujo en el baño con diseño inteligente y tecnología de vanguardia',
    exploreCollection: 'Explorar Colección',
    watchVideo: 'Ver Vídeo',
    featuredProducts: 'Productos Destacados',
    whyChooseUs: 'Por Qué Elegir Aureum VII Trading',
    testimonials: 'Lo Que Dicen Nuestros Clientes',
    certifications: 'Certificaciones y Estándares',
  },
  
  // Products
  products: {
    title: 'Nuestra Colección de Inodoros Inteligentes',
    subtitle: 'Descubra nuestra gama de soluciones inteligentes premium para el baño',
    features: 'Características',
    specifications: 'Especificaciones Técnicas',
    installation: 'Guía de Instalación',
    warranty: 'Información de Garantía',
    dimensions: 'Dimensiones',
    waterUsage: 'Consumo de Agua',
    powerConsumption: 'Consumo Energético',
    weight: 'Peso',
    material: 'Material',
    certification: 'Certificación',
    relatedProducts: 'Productos Relacionados',
  },
  
  // Contact
  contact: {
    title: 'Póngase en Contacto',
    subtitle: 'Nos encantaría saber de usted. Envíenos un mensaje y le responderemos lo antes posible.',
    name: 'Nombre Completo',
    email: 'Correo Electrónico',
    phone: 'Número de Teléfono',
    company: 'Nombre de la Empresa',
    message: 'Su Mensaje',
    sendMessage: 'Enviar Mensaje',
    ourLocation: 'Nuestra Ubicación',
    emailUs: 'Escríbanos',
    callUs: 'Llámenos',
    businessHours: 'Horario Comercial',
    weekdays: 'Lunes - Viernes: 9:00 - 18:00',
    weekend: 'Sábado - Domingo: Cerrado',
  },
  
  // About
  about: {
    title: 'Sobre Aureum VII Trading',
    subtitle: 'Su socio de confianza para soluciones de inodoros inteligentes premium en Europa',
    ourStory: 'Nuestra Historia',
    ourMission: 'Nuestra Misión',
    ourVision: 'Nuestra Visión',
    ourValues: 'Nuestros Valores',
    quality: 'Calidad',
    innovation: 'Innovación',
    sustainability: 'Sostenibilidad',
    customerFocus: 'Enfoque al Cliente',
  },
  
  // Footer
  footer: {
    description: 'Soluciones de inodoros inteligentes premium para el mercado europeo. Experimente lujo, innovación y sostenibilidad.',
    quickLinks: 'Enlaces Rápidos',
    products: 'Productos',
    support: 'Soporte',
    legal: 'Legal',
    privacyPolicy: 'Política de Privacidad',
    termsConditions: 'Términos y Condiciones',
    returnPolicy: 'Política de Devolución',
    shippingPolicy: 'Política de Envío',
    allRightsReserved: 'Todos los derechos reservados.',
    followUs: 'Síguenos',
  },
  
  // Forms
  forms: {
    required: 'Este campo es obligatorio',
    invalidEmail: 'Por favor, introduzca un correo electrónico válido',
    invalidPhone: 'Por favor, introduzca un número de teléfono válido',
    messageSent: '¡Su mensaje ha sido enviado correctamente!',
    errorSending: 'Hubo un error al enviar su mensaje. Por favor, inténtelo de nuevo.',
  },
  
  // FAQ
  faq: {
    title: 'Preguntas Frecuentes',
    subtitle: 'Encuentre respuestas a preguntas comunes sobre nuestros inodoros inteligentes',
    stillHaveQuestions: '¿Todavía tiene preguntas?',
    contactSupport: 'Contacte con nuestro equipo de soporte',
  },
  
  // Blog
  blog: {
    title: 'Últimos Artículos',
    subtitle: 'Manténgase actualizado con las últimas tendencias en tecnología de baños inteligentes',
    readingTime: 'min de lectura',
    author: 'Por',
    publishedOn: 'Publicado el',
    categories: 'Categorías',
    tags: 'Etiquetas',
    relatedArticles: 'Artículos Relacionados',
  },
  
  // Meta/SEO
  meta: {
    homeTitle: 'Inodoro Inteligente REM7 España | Aureum VII',
    homeDescription: 'Descubra REM7, el inodoro inteligente insignia que se lanza en España. Solicite una demostración privada o precios para proyectos en Marbella.',
    productsTitle: 'Colección de Inodoros Inteligentes | Aureum VII Trading',
    productsDescription: 'Descubra LUXA, LUNA, NOVA, ARIA y toda la gama REM7: inodoros inteligentes premium con bidé, calefacción y esterilización UV para hogares de lujo en Europa.',
    contactTitle: 'Contacto | Aureum VII Trading',
    contactDescription: 'Póngase en contacto con Aureum VII Trading para solicitar una cotización, hacer una consulta comercial o resolver dudas sobre nuestros inodoros inteligentes.',
    aboutTitle: 'Sobre Nosotros | Aureum VII Trading',
    aboutDescription: 'Aureum VII Trading (REM7) diseña inodoros inteligentes premium para hogares de lujo en Europa, combinando tecnología avanzada con artesanía europea.',
    defaultTitle: 'Aureum VII Trading | Inodoros Inteligentes de Lujo Europa',
    defaultDescription: 'Inodoros inteligentes premium con asientos calefactados, funciones de bidé y tecnología inteligente. Calidad y diseño europeo.',
    rem7Title: 'REM7 — Inodoro Inteligente Insignia | Aureum VII Trading',
    rem7Description: 'REM7, el inodoro inteligente insignia de Aureum VII Trading, se lanza en España. Solicite una demostración privada o precios para proyectos. Oferta especial: 600 € por unidad',
    luxaTitle: 'LUXA — Inodoro Inteligente de Lujo | Aureum VII Trading',
    luxaDescription: 'LUXA combina diseño europeo y tecnología avanzada: bidé con temperatura ajustable, luz LED nocturna y esterilización UV. Oferta especial: 600 € por unidad',
    bathSanitaryTitle: 'Bañeras y Sanitarios de Lujo | Aureum VII Trading',
    bathSanitaryDescription: 'Catálogo B2B de bañeras, spas de hidromasaje, lavabos y muebles de baño premium. Precios por volumen para hoteles, promotores y arquitectos en toda Europa.',
    businessTitle: 'Soluciones B2B para Hoteles y Promotores | Aureum VII Trading',
    businessDescription: 'Precios especiales por volumen, soporte OEM y logística en toda Europa para arquitectos, hoteles y promotores inmobiliarios. Solicite una cotización comercial.',
    compareTitle: 'Comparar Modelos de Inodoros Inteligentes | Aureum VII Trading',
    compareDescription: 'Compare las funciones, precios y especificaciones de todos los modelos REM7 lado a lado para encontrar el inodoro inteligente adecuado para su hogar.',
    faqTitle: 'Preguntas Frecuentes | Aureum VII Trading',
    faqDescription: 'Respuestas sobre instalación, garantía, mantenimiento y precios de los inodoros inteligentes REM7. Todo lo que necesita saber antes de comprar.',
  },
  
  // Product Pages
  productPages: {
    luna: {
      title: 'LUNA M9 Inodoro Inteligente de Lujo | Tecnología Spa',
      description: 'Descubre el inodoro inteligente LUNA M9 con calefacción instantánea, pantalla digital, limpieza tipo spa y funciones de bienestar.',
      heroTitle: 'LUNA',
      heroSubtitle: 'Modelo M9',
      heroDescription: 'El inodoro inteligente de lujo LUNA M9 combina elegancia atemporal con funcionalidad avanzada orientada al bienestar.',
      features: {
        heatedSeat: 'Asiento calefactado con luz nocturna',
        washModes: 'Múltiples modos de lavado',
        dryingFunction: 'Función de secado inteligente',
        modernDesign: 'Diseño moderno y delgado',
      },
      cta: {
        downloadSpec: 'Descargar Especificaciones',
        backToCollections: '← Volver a Colecciones',
        requestQuote: 'Solicitar Presupuesto',
      },
    },
    luxa: {
      title: 'LUXA M80 Inodoro Inteligente Premium | Sistema Bidé de Lujo',
      description: 'Inodoro inteligente insignia LUXA M80 con sensores de movimiento, calefacción sin tanque, esterilización UV y automatización premium.',
      heroTitle: 'LUXA',
      heroSubtitle: 'Modelo: M80',
      heroDescription: 'El LUXA M80 es la insignia de nuestra colección premium, representando la cúspide de la innovación en baños inteligentes.',
      features: {
        motionSensor: 'Tapa con sensor de movimiento',
        tanklessHeating: 'Calefacción instantánea sin tanque',
        adjustableTemp: 'Temperatura y presión de agua ajustables',
        premiumCeramic: 'Cerámica premium + tapa de cierre suave',
        ecoDesign: 'Diseño ecológico',
      },
      cta: {
        downloadSpec: 'Descargar Especificaciones',
        backToCollections: '← Volver a Colecciones',
        requestQuote: 'Solicitar Presupuesto',
      },
    },
    aria: {
      title: 'ARIA H60 Inodoro Inteligente Suspendido | Diseño Ahorra Espacio',
      description: 'Inodoro inteligente suspendido ARIA H60 con diseño arquitectónico elegante, tecnología de bidé avanzada e instalación ahorra espacio.',
      heroTitle: 'ARIA',
      heroSubtitle: 'Modelo H60',
      heroDescription: 'El ARIA H60 enfatiza el diseño arquitectónico minimalista con máximo confort y funcionalidad inteligente.',
      features: {
        bidetSpray: 'Spray de bidé ajustable',
        waterSaving: 'Tecnología de ahorro de agua',
        compactFit: 'Ajuste compacto para baños pequeños',
        softClose: 'Tapa de cierre suave',
      },
      cta: {
        downloadSpec: 'Descargar Especificaciones',
        backToCollections: '← Volver a Colecciones',
        requestQuote: 'Solicitar Presupuesto',
      },
    },
  },
};
